<div class="sell-covered-call-rebalance-settings">
    <div class="flex-row zero-bottom-margin">
        <div class="flex-column flex-column-header flex-green-button-header">
            <strong>Options</strong>
        </div>
        <div class="flex-column flex-green-button-container">
            <div>
                <button class="btn-medium-secondary" (click)="addAllocations()" [disabled]="isReadOnly" style="width: auto; margin-left:0px;">Select from Option Chain</button>
            </div>
        </div>
    </div>
    <div class="flex-row zero-bottom-margin">
        <div class="flex-column flex-column-header  flex-option-settings-header">
            <strong>Options settings</strong>
            <span class="tooltipIcon infoIcon suggested-name" calltoaction calltoactionPosition="right"
                  [calltoactionTemplate]="optionSettingsInfoToolTipIcon"></span>
        </div>
        <div class="flex-column">
            <div class="flex-option-settings-container">
                <div class="option-settings-row-container">
                    Specify values to apply to all securities listed below (optional)
                </div>
                <div class="option-settings-row-container">
                    <div class="option-settings-column-container">
                        <div class="option-settings-header">Percent of underlying to cover:</div>
                        <div>
                            <irb-number-text-box [(value)]="defaultPercentOfUnderlyingToCover" places="2" min="1"
                                                 max="100" [isPercentage]="true" [disabled]="isReadOnly"
                                                 width="80px"></irb-number-text-box>
                        </div>
                        <div>%</div>
                        <div><button id="applyPercentOfUnderlyingToCover" class="btn-medium-secondary btn-spacer"
                                     (click)="applyPercentOfUnderlyingToCover()"
                                     [disabled]="isReadOnly || defaultPercentOfUnderlyingToCover < 1
                                     || defaultPercentOfUnderlyingToCover > 100 || this?.data?.allocations?.length ===0">Apply</button></div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="flex-row">
        <div class="flex-column flex-column-header"></div>
        <div class="flex-column fixed-width-column">
            <div style="width:730px;">
                <irb-inventory-grid class="sell-coveredcall-grid" [style.width]="'730px'" [style.height]="'200px'" [gridHeight]="'200px'"
                                    [showSideBar]="false" [gridOptions]="gridOptions"
                                    [frameworkComponents]='frameworkComponents' (gridReady)="onGridReady($event)">
                </irb-inventory-grid>
            </div>
        </div>
    </div>

</div>
<ng-template #optionSettingsInfoToolTipIcon>
    <div>
      After selecting options chains, you can use these to quickly apply the same
      percentages for all symbols, so you don't have to enter the same settings
      for each security. You can edit the settings for any individual security
      after applying these same settings to all.
    </div>
  </ng-template>
